import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue"
  import { LPadrao } from "@/layouts"
  import TImportacoes from "@/components/Importacoes/TImportacoes/TImportacoes.vue"
  import { MenuItem } from "primevue/menuitem"
  import { useI18n } from "vue-i18n"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Importacoes',
  setup(__props) {

  const { t } = useI18n()

  const rotaBase = ref<MenuItem>({
    label: t("importacoes"),
    icon: "pi pi-file",
    to: "/importacoes",
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LPadrao), null, {
    default: _withCtx(() => [
      _createVNode(TImportacoes, { "rota-base": rotaBase.value }, null, 8, ["rota-base"])
    ]),
    _: 1
  }))
}
}

})